import React from 'react';
import T from 'i18n-react';
import FooterIcon from '../../../../images/footerIcon.svg';
import './footer.css';

const Footer = () => {
    return (
        <div className='footerContainer'>
            <div className='footerIcon'>
                <img src={FooterIcon} />
            </div>
            <div className='footerDisclaimerText'>
                {T.translate('Dashboard.labels.SecurityMessage')}
            </div>
        </div>
    )
}

export default Footer